import { render, staticRenderFns } from "./BankNameHokkokubank.vue?vue&type=template&id=1cb384fe&scoped=true&"
import script from "./BankNameHokkokubank.vue?vue&type=script&lang=ts&"
export * from "./BankNameHokkokubank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb384fe",
  null
  
)

export default component.exports